import React, { FC } from 'react';
import classNames from 'classnames';
import { TypePdfFields } from '@/core/generated-types';
import { Button } from '@/components';
import { BUTTON_SIZES, BUTTON_STYLES } from '@/components/ui/Buttons/utils';
import { downloadResource } from '@/components/common/PdfDownload/utils';
import { captureDownloadEvent, DOWNLOAD_EVENT_TYPES } from '@/utils/dataLayer';

type PdfDownloadProps = {
  pdf: TypePdfFields;
  classes?: string;
};

const PdfDownload: FC<PdfDownloadProps> = ({ pdf, classes }) => {
  const { downloadCTA, fileDownloadName, pdfAsset } = pdf;

  function onClick() {
    captureDownloadEvent(DOWNLOAD_EVENT_TYPES.PDF_DOWNLOAD, {
      fileName: fileDownloadName,
    });
    downloadResource(pdfAsset.fields.file.url, fileDownloadName);
  }
  return (
    <Button
      ctaText={downloadCTA}
      classes={classNames(classes)}
      size={BUTTON_SIZES.none}
      style={BUTTON_STYLES.link}
      onClick={onClick}
      data-testid="pdf-download-requested"
    />
  );
};

export default React.memo(PdfDownload);
